import _ from "lodash";
import { AssistantHttpGateway } from "../gateway/AssistantHttpGateway";
import { UserDataAdapter } from "../presentation/adpters/UserDataAdapter";
import { RolesUtils } from "../utils/roles/roles";

let config = null;

const setConfigs = async () => {
    const assistantHttpGateway = new AssistantHttpGateway();
    const setting = await assistantHttpGateway.getSetting({ name: "ACL" });
    config = setting?.config || null;
};

setConfigs();

/**
 * Busca uma dada permissão
 * @param {String} moduleName classe solicitada
 * @param {String} metodo método solicitado
 * @returns {String} all/accountingId/companyId/userId
 */
const getPermission = (moduleName, method) => {
    if (userIs(["Super", "API"])) return true;

    const roles = new UserDataAdapter().user()?.roles;

    if (_.isEmpty(roles)) return;

    const pathMethod = _findPathMethod({ roles, moduleName, method });

    return pathMethod;
};

/**
 * Encontra caminho do método
 * @param {object} params
 */
const _findPathMethod = ({ roles, moduleName, method } = {}) => {
    let pathMethod = null;
    for (const role of roles) {
        const existsMethodInRole = _.get(
            config,
            `${moduleName}.${role}.${method}`
        );
        if (existsMethodInRole) pathMethod = existsMethodInRole;
    }

    return pathMethod;
};

/**
 * Busca o usuário logado com validação nos arrays
 * @returns {Object} novo usuário
 */
const getUser = () => {
    const user = new UserDataAdapter().user()?.profile;
    if (!user.accountingIds) user.accountingIds = [];
    if (!user.companyIds) user.companyIds = [];
    return user;
};

const userIs = (roles) => {
    return RolesUtils.userIsInRole({ roles });
};

/**
 * Verifica se o usuário possui FeatureFlag do módulo
 * @param {String} model nome do módulo
 */
const hasFeatureFlag = (model) => {
    // Super consegue realizar qualquer ação
    if (userIs(["Super"])) return true;

    if (config) {
        const featureFlag = _.get(config[model], "FeatureFlag");
        const roles = new UserDataAdapter().user()?.roles;
        const founded = (roles || []).some(
            (role) => _.indexOf(featureFlag, role) >= 0
        );

        return founded || !_.size(featureFlag);
    }
};

/**
 * Checa se a permissão condiz com as permitidas pelo usuário
 * @param {String} permission all/accountingId/companyId/userId
 * @param {String} accountingId id da contabilidade afetada
 * @param {String} companyId id da empresa afetada
 * @param {String} userId id do usuário afetado
 * @returns {boolean} se usuário tem permissão
 */
const hasPermission = (permission, accountingId, companyId, userId) => {
    const user = getUser();
    const permissions = {
        all: true,
        accountingId: user.accountingIds.indexOf(accountingId) > -1,
        companyId: user.companyIds.indexOf(companyId) > -1,
        userId: userId ? new UserDataAdapter().user()?._id == userId : true
    };
    return permissions[permission] || false;
};

/**
 * Verifica se usuário está logado
 * @returns {boolean} usuário logado ou não
 */
const isLoggedIn = () => {
    return new UserDataAdapter().user()?._id;
};

/**
 * Atualiza o ACL com novo documento
 * @param {Object} acl novo acl
 */
const refreshACL = (acl) => (config = acl);

export const Validations = {
    getPermission,
    getUser,
    hasFeatureFlag,
    hasPermission,
    isLoggedIn,
    userIs,
    refreshACL,
    setConfigs
};
